/**
 * Stores Apple Pay token and installment information in the session storage.
 * @param {Object} appleToken - The Apple Pay token object.
 * @param {Object} installment - The installment information.
 */
export const saveApplePaymentInfo = (appleToken, installment) => {
  if (!appleToken || !installment) return

  const paymentInfo = {
    card: {
      type: appleToken.paymentMethod.type,
      flag: appleToken.paymentMethod.network,
    },
    installment,
  }

  sessionStorage.setItem('applePaymentInfo', JSON.stringify(paymentInfo))
}

/**
 * Retrieves Apple Pay payment information from session storage.
 * @returns {Object|null} The stored payment information or null if not found.
 */
export const getApplePaymentInfo = () => {
  const paymentInfo = sessionStorage.getItem('applePaymentInfo')

  if (!paymentInfo)
    return {
      card: {
        type: '',
        flag: '',
      },
      installment: {},
    }

  try {
    return JSON.parse(paymentInfo)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to parse Apple payment info from sessionStorage', error)
    return null
  }
}

/**
 * Removes Apple Pay payment information from session storage.
 */
export const clearApplePaymentInfo = () => {
  sessionStorage.removeItem('applePaymentInfo')
}
